// File Name: src/pages/RegisterTeamsPage.js

import React from 'react';
import { Row, Col, Typography, Button, Card } from 'antd';
import { useNavigate } from 'react-router-dom';
import MedalImage from '../assets/madel.png';
import FootBallImage from '../assets/ready_to_connect_football_image.png';
import CricketImage from '../assets/ready_to_connect_cricket_image.png';
import JiuJitsuImage from '../assets/ready_to_connect_jiu_image.png';

const { Title, Text } = Typography;

const sportsData = [
  { name: 'Football', image: FootBallImage },
  { name: 'Cricket', image: CricketImage },
  { name: 'Jiu-jitsu', image: JiuJitsuImage },
];

const RegisterTeamsPage = () => {
  const navigate = useNavigate();

  const pageContainerStyle = {
    maxWidth: '1200px',
    margin: '40px auto',
    padding: '20px',
  };

  const headlineStyle = {
    color: '#6e4598',
    fontSize: '36px',
    marginBottom: '30px',
  };
  
  const iconButtonStyle = {
    marginRight: '15px',
    borderColor: '#6e4598',
    color: '#6e4598',
    fontWeight: 'bold',
    height: '50px',
    padding: '0 30px',
    fontSize: '16px',
  };

  const sportCardStyle = {
    textAlign: 'center',
    border: 'none',
    borderRadius: '12px', 
    overflow: 'hidden',
    padding: '0 0 10px 0',
  };
  
  const imageStyle = {
    width: '100%',
    height: '250px',
    objectFit: 'cover',
    borderRadius: '12px', 
  };
  
  const sportTitleStyle = {
    margin: '0 0 15px 0', 
    fontWeight: 'bold', 
    fontSize: '20px',
    color: '#000000',
  };

  // Debug the navigation
  const handleJoinAsPlayer = () => {
    console.log('Join as player button clicked');
    console.log('Attempting to navigate to /contact-form');
    
    // Try different navigation approaches
    try {
      navigate('/contact-form');
      console.log('Navigation function called successfully');
    } catch (error) {
      console.error('Navigation error:', error);
      // Fallback: use window.location
      window.location.href = '/contact-form';
    }
  };

  // Alternative approach using window.location
  const handleJoinAsPlayerAlternative = () => {
    window.location.href = '/contact-form';
  };

  return (
    <div style={pageContainerStyle}>
      <Row gutter={[40, 40]} align="middle">
        <Col xs={24} md={14}>
          <Title level={1} style={headlineStyle}>Ready to Join the Action?</Title>
          
          <Text style={{ display: 'block', marginBottom: '10px', fontSize: '16px' }}>
            Anyone can be part of the game - no barriers, no limits. 
            We believe in community sports for everyone, where passion meets purpose.
          </Text>
          
          <div style={{ marginTop: '20px', marginBottom: '20px' }}>
            <Text strong style={{ color: '#6e4598' }}>At Yalla Nellab, we:</Text>
            <ul style={{ listStyleType: 'disc', paddingLeft: '20px', fontSize: '15px' }}>
              <li>Organize & host events that bring people together</li>
              <li>Support community sports across all levels</li>
              <li>Raise awareness about the power of play</li>
              <li>Conduct workshops & seminars to build skills and confidence</li>
            </ul>
          </div>
          
          <div style={{ marginTop: '20px' }}>
            <Button 
              style={iconButtonStyle}
              size="large"
              onClick={handleJoinAsPlayer}
            >
              Join as player
            </Button>
          </div>
        </Col>
        
        <Col xs={24} md={10} style={{ textAlign: 'center' }}>
          <img 
            src={MedalImage}
            alt="Yalla Nellab Medal" 
            style={{ maxWidth: '300px', width: '100%' }} 
          />
        </Col>
      </Row>

      {/* Sports Section */}
      <div style={{ textAlign: 'center', margin: '80px 0 40px 0' }}>
        <Title level={3} style={{ color: '#000000' }}>Sports at Yalla Nellab</Title>
        <Text type="secondary">Bringing people together through the spirit of sports</Text>
      </div>

      <Row gutter={[30, 30]} justify="center">
        {sportsData.map((sport) => (
          <Col xs={24} sm={8} key={sport.name}>
            <Card 
              hoverable
              style={sportCardStyle}
              bodyStyle={{ padding: '0' }}
            >
              <Title level={4} style={sportTitleStyle}>{sport.name}</Title>
              <img alt={sport.name} src={sport.image} style={imageStyle} />
            </Card>
          </Col>
        ))}
      </Row>
      
      <div style={{ marginTop: '80px' }}>
        <Title level={2}>How It Works</Title>
        <ol style={{ fontSize: '16px', lineHeight: '2.5' }}>
          <li>Click on Join as player button</li>
          <li>Share your team name & player details</li>
          <li>Receive confirmation from our team</li>
          <li>You will be informed about upcoming tournaments and you can easily register for them</li>
        </ol>
      </div>
    </div>
  );
};

export default RegisterTeamsPage;